/* ===== Theme logic — real Shopify cart (AJAX) ===== */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.__moneyFormat || "${{amount}}")
      : "$" + (cents / 100).toFixed(2);

  /* ---------------- Product page: variants, swatches, bundles ---------------- */
  const form = $("#product-form");
  if (form) {
    const variants = JSON.parse($("#variant-data").textContent || "[]");
    const optionNames = JSON.parse($("#option-names").textContent || "[]");
    const idInput = $("#variant-id", form);
    const qtyInput = $("#quantity", form);
    const priceEl = $("#price-current");
    const atcTotalEls = $$(".js-atc-total");
    const atcBtns = $$(".js-add");
    const selected = {}; // optionName -> value

    // seed defaults from any .active swatch
    $$("[data-opt]").forEach((b) => {
      if (b.classList.contains("active")) selected[b.dataset.opt] = b.dataset.val;
    });

    function currentVariant() {
      return variants.find((v) =>
        optionNames.every((n, i) => v.options[i] === selected[n])
      );
    }

    function bundleQty() {
      const active = $("#bundles .bundle.active");
      return active ? parseInt(active.dataset.qty, 10) : 1;
    }

    function refresh() {
      const v = currentVariant();
      const qty = bundleQty();
      if (qtyInput) qtyInput.value = qty;
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        const total = money(v.price * qty);
        atcTotalEls.forEach((e) => (e.textContent = total));
        atcBtns.forEach((b) => {
          b.disabled = !v.available;
          if (!v.available) b.dataset.label = b.textContent;
          b.querySelector(".js-atc-label") &&
            (b.querySelector(".js-atc-label").textContent = v.available ? "Add to Cart" : "Sold out");
        });
      } else {
        atcBtns.forEach((b) => (b.disabled = true));
      }
    }

    // option swatches (size / color / any)
    $$("[data-opt]").forEach((b) =>
      b.addEventListener("click", () => {
        const name = b.dataset.opt;
        $$(`[data-opt="${CSS.escape(name)}"]`).forEach((x) => x.classList.remove("active"));
        b.classList.add("active");
        selected[name] = b.dataset.val;
        refresh();
      })
    );

    // bundle (quantity) buttons
    $$("#bundles .bundle").forEach((b) =>
      b.addEventListener("click", () => {
        $$("#bundles .bundle").forEach((x) => x.classList.remove("active"));
        b.classList.add("active");
        refresh();
      })
    );

    // gallery thumbs
    $$(".thumb").forEach((t) =>
      t.addEventListener("click", () => {
        $$(".thumb").forEach((x) => x.classList.remove("active"));
        t.classList.add("active");
        const main = $("#mainImg");
        if (main && t.dataset.img) main.src = t.dataset.img;
      })
    );

    // add to cart -> AJAX
    atcBtns.forEach((btn) =>
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        const v = currentVariant();
        if (!v || !v.available) return toast("Please choose an available option");
        btn.disabled = true;
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: v.id, quantity: bundleQty() }),
          });
          await loadCart();
          openCart();
          toast("Added to cart \uD83D\uDC3E");
        } catch (err) {
          toast("Something went wrong — try again");
        } finally {
          btn.disabled = false;
        }
      })
    );

    refresh();
  }

  /* ---------------- Cart drawer (all pages) ---------------- */
  const drawer = $("#cartDrawer");
  const overlay = $("#cartOverlay");
  function openCart() { drawer && drawer.classList.add("open"); overlay && overlay.classList.add("open"); }
  function closeCart() { drawer && drawer.classList.remove("open"); overlay && overlay.classList.remove("open"); }
  $("#openCart") && $("#openCart").addEventListener("click", (e) => { e.preventDefault(); loadCart(); openCart(); });
  $("#closeCart") && $("#closeCart").addEventListener("click", closeCart);
  overlay && overlay.addEventListener("click", closeCart);
  $("#checkout") && $("#checkout").addEventListener("click", () => { window.location.href = "/checkout"; });

  async function loadCart() {
    const body = $("#cartBody");
    if (!body) return;
    const cart = await (await fetch("/cart.js")).json();
    $("#cartCount") && ($("#cartCount").textContent = cart.item_count);
    $("#cartTotal") && ($("#cartTotal").textContent = money(cart.total_price));
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      return;
    }
    body.innerHTML = cart.items
      .map(
        (it, i) => `
      <div class="cart-item">
        <img src="${it.image ? it.image.replace(/(\.[^.\/]+)(\?|$)/, "_120x$1$2") : ""}" alt="">
        <div class="ci-main">
          <div class="ci-title">${it.product_title}</div>
          <div class="ci-opt">${(it.options_with_values || []).map((o) => o.value).join(" \u00B7 ")}</div>
          <div class="ci-row">
            <div class="qty">
              <button data-line="${i + 1}" data-to="${it.quantity - 1}">\u2212</button>
              <span>${it.quantity}</span>
              <button data-line="${i + 1}" data-to="${it.quantity + 1}">+</button>
            </div>
            <span class="ci-price">${money(it.final_line_price)}</span>
          </div>
          <button class="ci-remove" data-line="${i + 1}" data-to="0">Remove</button>
        </div>
      </div>`
      )
      .join("");
    $$("[data-line]", body).forEach((b) =>
      b.addEventListener("click", async () => {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.to, 10) }),
        });
        loadCart();
      })
    );
  }
  loadCart();

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("show"), 2200);
  }

  /* ---------------- Countdown + stock urgency (visual only) ---------------- */
  const cd = $("#countdown");
  if (cd) {
    let remaining = 14 * 60 + 59;
    setInterval(() => {
      if (remaining <= 0) remaining = 14 * 60 + 59;
      remaining--;
      cd.textContent =
        String(Math.floor(remaining / 60)).padStart(2, "0") + ":" + String(remaining % 60).padStart(2, "0");
    }, 1000);
  }
  const stock = $("#stockLeft");
  if (stock) {
    setInterval(() => {
      if (Math.random() > 0.6) {
        const n = parseInt(stock.textContent, 10);
        if (n > 6) stock.textContent = n - 1;
      }
    }, 9000);
  }
})();
